/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AdmDefinitionResponse } from "../models/adm-definition-response";
import { AdmDefinitionIssue } from "../models/adm-definition-issue";
import { AdmSaveResult } from "../models/adm-save-result";
import { AdmSource } from "../models/adm-source";
import { AdmTable } from "../models/adm-table";
import { AdmFieldGroup } from "../models/adm-field-group";
import { AdmTableColumn } from "../models/adm-table-column";
import { AdmReorderColumnsRequest } from "../models/adm-reorder-columns-request";
import { AdmMoveColumnsResponse } from "../models/adm-move-columns-response";
import { AdmMoveColumnsRequest } from "../models/adm-move-columns-request";
import { AdmSetColumnFlagsResponse } from "../models/adm-set-column-flags-response";
import { AdmSetColumnFlagsRequest } from "../models/adm-set-column-flags-request";
import { AdmSaveRelationshipRequest } from "../models/adm-save-relationship-request";
import { AdmSaveFlattenedColumnRequest } from "../models/adm-save-flattened-column-request";
import { AdmRerouteResponse } from "../models/adm-reroute-response";
import { AdmRerouteRequest } from "../models/adm-reroute-request";
import { AdmStaleLayoutsResponse } from "../models/adm-stale-layouts-response";
import { AdmFilterPointEx } from "../models/adm-filter-point-ex";
import { AdmSetRetiredRequest } from "../models/adm-set-retired-request";
@Injectable({
  providedIn: "root",
})
class AdminAdmDefinitionService extends __BaseService {
  static readonly adminAdmDefinitionGetDefinitionPath =
    "/api/AdminAdmDefinition/Definition";
  static readonly adminAdmDefinitionValidatePath =
    "/api/AdminAdmDefinition/Validate";
  static readonly adminAdmDefinitionSaveSourcePath =
    "/api/AdminAdmDefinition/SaveSource";
  static readonly adminAdmDefinitionSaveTablePath =
    "/api/AdminAdmDefinition/SaveTable";
  static readonly adminAdmDefinitionSaveFieldGroupPath =
    "/api/AdminAdmDefinition/SaveFieldGroup";
  static readonly adminAdmDefinitionDeleteFieldGroupPath =
    "/api/AdminAdmDefinition/DeleteFieldGroup/{fieldGroupId}";
  static readonly adminAdmDefinitionSaveColumnPath =
    "/api/AdminAdmDefinition/SaveColumn";
  static readonly adminAdmDefinitionReorderColumnsPath =
    "/api/AdminAdmDefinition/ReorderColumns";
  static readonly adminAdmDefinitionMoveColumnsPath =
    "/api/AdminAdmDefinition/MoveColumns";
  static readonly adminAdmDefinitionSetColumnFlagsPath =
    "/api/AdminAdmDefinition/SetColumnFlags";
  static readonly adminAdmDefinitionSaveRelationshipPath =
    "/api/AdminAdmDefinition/SaveRelationship";
  static readonly adminAdmDefinitionDeleteRelationshipPath =
    "/api/AdminAdmDefinition/DeleteRelationship/{relationshipId}";
  static readonly adminAdmDefinitionSaveFlattenedColumnPath =
    "/api/AdminAdmDefinition/SaveFlattenedColumn";
  static readonly adminAdmDefinitionPreviewReroutePath =
    "/api/AdminAdmDefinition/PreviewReroute";
  static readonly adminAdmDefinitionApplyReroutePath =
    "/api/AdminAdmDefinition/ApplyReroute";
  static readonly adminAdmDefinitionGetStaleLayoutsPath =
    "/api/AdminAdmDefinition/StaleLayouts/{tableId}";
  static readonly adminAdmDefinitionRegenerateStalePath =
    "/api/AdminAdmDefinition/RegenerateStale/{tableId}";
  static readonly adminAdmDefinitionGetRegenerableLayoutsPath =
    "/api/AdminAdmDefinition/RegenerableLayouts";
  static readonly adminAdmDefinitionRegenerateAllPath =
    "/api/AdminAdmDefinition/RegenerateAll";
  static readonly adminAdmDefinitionDeleteFlattenedColumnPath =
    "/api/AdminAdmDefinition/DeleteFlattenedColumn/{columnId}";
  static readonly adminAdmDefinitionSaveFilterPointPath =
    "/api/AdminAdmDefinition/SaveFilterPoint";
  static readonly adminAdmDefinitionSetRetiredPath =
    "/api/AdminAdmDefinition/SetRetired";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminAdmDefinitionGetDefinitionResponse(): __Observable<
    __StrictHttpResponse<AdmDefinitionResponse>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmDefinition/Definition`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmDefinitionResponse>;
      })
    );
  }
  adminAdmDefinitionGetDefinition(): __Observable<AdmDefinitionResponse> {
    return this.adminAdmDefinitionGetDefinitionResponse().pipe(
      __map((_r) => _r.body as AdmDefinitionResponse)
    );
  }
  adminAdmDefinitionValidateResponse(): __Observable<
    __StrictHttpResponse<Array<AdmDefinitionIssue>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmDefinition/Validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmDefinitionIssue>>;
      })
    );
  }
  adminAdmDefinitionValidate(): __Observable<Array<AdmDefinitionIssue>> {
    return this.adminAdmDefinitionValidateResponse().pipe(
      __map((_r) => _r.body as Array<AdmDefinitionIssue>)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveSourceResponse(
    request: AdmSource
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveSource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveSource(
    request: AdmSource
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveSourceResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveTableResponse(
    request: AdmTable
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveTable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveTable(request: AdmTable): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveTableResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveFieldGroupResponse(
    request: AdmFieldGroup
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveFieldGroup`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveFieldGroup(
    request: AdmFieldGroup
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveFieldGroupResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param fieldGroupId undefined
   */
  adminAdmDefinitionDeleteFieldGroupResponse(
    fieldGroupId: number
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/DeleteFieldGroup/${fieldGroupId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param fieldGroupId undefined
   */
  adminAdmDefinitionDeleteFieldGroup(
    fieldGroupId: number
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionDeleteFieldGroupResponse(fieldGroupId).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveColumnResponse(
    request: AdmTableColumn
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveColumn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveColumn(
    request: AdmTableColumn
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveColumnResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionReorderColumnsResponse(
    request: AdmReorderColumnsRequest
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/ReorderColumns`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionReorderColumns(
    request: AdmReorderColumnsRequest
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionReorderColumnsResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionMoveColumnsResponse(
    request: AdmMoveColumnsRequest
  ): __Observable<__StrictHttpResponse<AdmMoveColumnsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/MoveColumns`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmMoveColumnsResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionMoveColumns(
    request: AdmMoveColumnsRequest
  ): __Observable<AdmMoveColumnsResponse> {
    return this.adminAdmDefinitionMoveColumnsResponse(request).pipe(
      __map((_r) => _r.body as AdmMoveColumnsResponse)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSetColumnFlagsResponse(
    request: AdmSetColumnFlagsRequest
  ): __Observable<__StrictHttpResponse<AdmSetColumnFlagsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SetColumnFlags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSetColumnFlagsResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSetColumnFlags(
    request: AdmSetColumnFlagsRequest
  ): __Observable<AdmSetColumnFlagsResponse> {
    return this.adminAdmDefinitionSetColumnFlagsResponse(request).pipe(
      __map((_r) => _r.body as AdmSetColumnFlagsResponse)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveRelationshipResponse(
    request: AdmSaveRelationshipRequest
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveRelationship`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveRelationship(
    request: AdmSaveRelationshipRequest
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveRelationshipResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param relationshipId undefined
   */
  adminAdmDefinitionDeleteRelationshipResponse(
    relationshipId: number
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdminAdmDefinition/DeleteRelationship/${relationshipId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param relationshipId undefined
   */
  adminAdmDefinitionDeleteRelationship(
    relationshipId: number
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionDeleteRelationshipResponse(
      relationshipId
    ).pipe(__map((_r) => _r.body as AdmSaveResult));
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveFlattenedColumnResponse(
    request: AdmSaveFlattenedColumnRequest
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveFlattenedColumn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveFlattenedColumn(
    request: AdmSaveFlattenedColumnRequest
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveFlattenedColumnResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionPreviewRerouteResponse(
    request: AdmRerouteRequest
  ): __Observable<__StrictHttpResponse<AdmRerouteResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/PreviewReroute`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmRerouteResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionPreviewReroute(
    request: AdmRerouteRequest
  ): __Observable<AdmRerouteResponse> {
    return this.adminAdmDefinitionPreviewRerouteResponse(request).pipe(
      __map((_r) => _r.body as AdmRerouteResponse)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionApplyRerouteResponse(
    request: AdmRerouteRequest
  ): __Observable<__StrictHttpResponse<AdmRerouteResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/ApplyReroute`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmRerouteResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionApplyReroute(
    request: AdmRerouteRequest
  ): __Observable<AdmRerouteResponse> {
    return this.adminAdmDefinitionApplyRerouteResponse(request).pipe(
      __map((_r) => _r.body as AdmRerouteResponse)
    );
  }

  /**
   * @param tableId undefined
   */
  adminAdmDefinitionGetStaleLayoutsResponse(
    tableId: number
  ): __Observable<__StrictHttpResponse<AdmStaleLayoutsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmDefinition/StaleLayouts/${tableId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmStaleLayoutsResponse>;
      })
    );
  }
  /**
   * @param tableId undefined
   */
  adminAdmDefinitionGetStaleLayouts(
    tableId: number
  ): __Observable<AdmStaleLayoutsResponse> {
    return this.adminAdmDefinitionGetStaleLayoutsResponse(tableId).pipe(
      __map((_r) => _r.body as AdmStaleLayoutsResponse)
    );
  }

  /**
   * @param tableId undefined
   */
  adminAdmDefinitionRegenerateStaleResponse(
    tableId: number
  ): __Observable<__StrictHttpResponse<AdmStaleLayoutsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/RegenerateStale/${tableId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmStaleLayoutsResponse>;
      })
    );
  }
  /**
   * @param tableId undefined
   */
  adminAdmDefinitionRegenerateStale(
    tableId: number
  ): __Observable<AdmStaleLayoutsResponse> {
    return this.adminAdmDefinitionRegenerateStaleResponse(tableId).pipe(
      __map((_r) => _r.body as AdmStaleLayoutsResponse)
    );
  }
  adminAdmDefinitionGetRegenerableLayoutsResponse(): __Observable<
    __StrictHttpResponse<AdmStaleLayoutsResponse>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmDefinition/RegenerableLayouts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmStaleLayoutsResponse>;
      })
    );
  }
  adminAdmDefinitionGetRegenerableLayouts(): __Observable<AdmStaleLayoutsResponse> {
    return this.adminAdmDefinitionGetRegenerableLayoutsResponse().pipe(
      __map((_r) => _r.body as AdmStaleLayoutsResponse)
    );
  }
  adminAdmDefinitionRegenerateAllResponse(): __Observable<
    __StrictHttpResponse<AdmStaleLayoutsResponse>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/RegenerateAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmStaleLayoutsResponse>;
      })
    );
  }
  adminAdmDefinitionRegenerateAll(): __Observable<AdmStaleLayoutsResponse> {
    return this.adminAdmDefinitionRegenerateAllResponse().pipe(
      __map((_r) => _r.body as AdmStaleLayoutsResponse)
    );
  }

  /**
   * @param columnId undefined
   */
  adminAdmDefinitionDeleteFlattenedColumnResponse(
    columnId: number
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdminAdmDefinition/DeleteFlattenedColumn/${columnId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param columnId undefined
   */
  adminAdmDefinitionDeleteFlattenedColumn(
    columnId: number
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionDeleteFlattenedColumnResponse(columnId).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveFilterPointResponse(
    request: AdmFilterPointEx
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SaveFilterPoint`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSaveFilterPoint(
    request: AdmFilterPointEx
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSaveFilterPointResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmDefinitionSetRetiredResponse(
    request: AdmSetRetiredRequest
  ): __Observable<__StrictHttpResponse<AdmSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmDefinition/SetRetired`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmDefinitionSetRetired(
    request: AdmSetRetiredRequest
  ): __Observable<AdmSaveResult> {
    return this.adminAdmDefinitionSetRetiredResponse(request).pipe(
      __map((_r) => _r.body as AdmSaveResult)
    );
  }
}

module AdminAdmDefinitionService {}

export { AdminAdmDefinitionService };
